import styled from 'styled-components';

export const ScNotFound = styled.div`
  padding: 16px 24px;
  border: 1px solid transparent;
  border-radius: 8px;

  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
`;
